import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import ResuableCard from "./Resuablecard";


export default function ReferralHistoryMobile({ total, open, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-white dark:bg-gray-950">
      {/* header */}
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3 dark:border-gray-800">
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">
          Earning History
        </h3>
        <button
          className="rounded-full p-2 text-gray-500"
          onClick={onClose}
          aria-label="Close"
        >
          <AiOutlineClose size={18} />
        </button>
      </div>
      {/* content */}
      <div className="h-[calc(100vh-52px)] overflow-y-auto px-4 py-4">
        <ResuableCard total={total} />
      </div>
    </div>
  );
}
